import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { RequestInProgressService }  from '@trivelope/triv-ui-tools-lib';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DataInput }  from '@trivelope/triv-ui-tools-lib';
import { MatDialog } from '@angular/material/dialog';
import { Member } from 'src/app/classes/member';
import { MemberService } from 'src/app/services/member.service';
import { map, of, switchMap } from 'rxjs';
import { Environment } from 'src/app/classes/environment';
import { User } from 'src/app/classes/user';
import { UserService } from 'src/app/services/user.service';


@Component({
	selector: 'app-my-member',
	templateUrl: './my-member.component.html',
	styleUrls: ['./my-member.component.css']
})
export class MyMemberComponent implements OnInit {


	member = new Member();
	formG1: UntypedFormGroup = this._fb.group({});
	myInputs: { [name: string]: DataInput } = {};
	bLoading = true;
	bError = false;

	users: User[] = [];
	usernames: { [key:string]: string } = {};



	constructor(
		public requestInProgressService: RequestInProgressService,
		private _fb: UntypedFormBuilder,
		public matDialog: MatDialog,
		private memberService: MemberService,
		@Inject('environment') private environment: Environment,
		private userService: UserService,
	) {}


	ngOnInit() {

		for( let dataInput of this.environment.member ) {
			this.myInputs[ dataInput.id ] = dataInput;
		}

		this.memberService.getMyMember().pipe(
			switchMap( member => {

				if( !member || !member.mitgliedId ) return of(false);
				this.member = member;

				this.formG1.patchValue( member );

				return this.userService.getAll().pipe(
					map( users => {

						// looking for users who are already in this Mitglied and are not admin
						this.users = users
							.filter( u => (u.mitgliedId == member.mitgliedId) )
							.filter( u => !u.gruppen || !u.gruppen.includes( 'ADMIN' ) );

						for( let user of users ) {
							const arr: string[] = [];
							if( user.ebeVorname ) arr.push( user.ebeVorname );
							if( user.ebeName ) arr.push( user.ebeName );
							this.usernames[ user.ebeId ] = ( arr.join( " " ) || user.ebeId );
						}

						return true;

					} )
				)

			} )

		).subscribe( b => {
			this.bLoading = false;
			this.bError = !b;
		} );

	}



	reset() {
		console.log( 'reset()', this.formG1 )
		this.formG1.reset();
	}

}
